import { Helmet } from "react-helmet-async"
import { Breadcrumbs, ButtonLink } from "@sembark-travel/ui/router"
import { CreateCabMetricsPricesSheetWithFolder } from "../../../../../DataDrive/Metric"
import { generatePath, useLocation } from "../../../../../router-utils"
import { TSheetFolder } from "../../../../../DataDrive"
import { Icons } from "@sembark-travel/ui/base"

export default function CreateNewMetricPricesSheetFolderPage() {
	const location = useLocation()
	const folderDetails: TSheetFolder | undefined = location.state?.folderDetails
	return (
		<>
			<Helmet>
				<title>Create Cab Metric Prices Sheet Folder</title>
			</Helmet>
			<Breadcrumbs
				title="Create Cab Metric Prices Sheet Folder"
				items={[
					[generatePath("/data-drive"), "Data Drive"],
					["", "Metric Sheet"],
				]}
				actions={
					<ButtonLink
						to={generatePath("/data-drive/folders/upload-prices/metric-sheets")}
						level="primary"
						state={{ folderDetails: folderDetails }}
					>
						<Icons.Upload />
						Upload Via CSV
					</ButtonLink>
				}
			/>

			<CreateCabMetricsPricesSheetWithFolder folderDetails={folderDetails} />
		</>
	)
}
